export const INITIAL_PROMO = "INITIAL_PROMO";
export const DETAIL_PROMO = "DETAIL_PROMO";